import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '账户信息',
    type: 1,
    labelClass: 'blue',
    labelName: '账',
    formList: [
      {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'type',
        fieldName: '类型',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'UserPayType',
          pickerType: '',
          filterable: true,
          selectType: 1// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '开户信息',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'branchName',
        fieldName: '账户昵称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'account',
        fieldName: '账号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'content',
        fieldName: '备注',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }
    ]
  }
]
